import { atom } from "jotai";

export const searchOpenAtom = atom(false);
